import { defineStore } from 'pinia'
import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

export const appointment = defineStore('appointment', {
    state: () => ({
        userId: null,
        locationId: null,
        agentId: null,        
        selectedServices:[],
        media:{
          enagement_upload_uuids: [],
          bespoke_upload_uuids: [],
        },
        servicesForm: {
            eng_ring: {
              label: 'Engagement Rings',
              desciption: 'Help us prepare - answer these questions!',
              id: '1',
              value: 'eng_ring',
              filters: [
                {
                  type: 'box',
                  label: "What's your preferred diamond shape?",
                  value: 'shape',
                  options: [
                    { id: 1, label: 'Round', icon: 'round', active: 0 },
                    { id: 2, label: 'Oval', icon: 'oval', active: 0 },
                    { id: 3, label: 'Pear', icon: 'pear', active: 0 },
                    { id: 4, label: 'Cushion', icon: 'cushion', active: 0 },
                    { id: 5, label: 'Princess', icon: 'princess', active: 0 }, 
                    { id: 6, label: 'Radiant', icon: 'radiant', active: 0 },
                    { id: 7, label: 'Emerald', icon: 'emerald', active: 0 },
                    { id: 8, label: 'Heart', icon: 'heart', active: 0 },
                    { id: 9, label: 'Asscher', icon: 'asscher', active: 0 },
                    { id: 10, label: 'Marquise', icon: 'marquise', active: 0 },
                    { id: 11, label: 'Fiery Rounds', icon: 'fiery_round', active: 0 },
                  ]
                },
                {
                  type: 'box',
                  label: "What's your preferred ring style?",
                  value: 'style',
                  multiselect: true,
                  options: [
                    { id: 1, label: 'Solitaire', icon: 'solitaire', active: 0 },
                    { id: 2, label: 'Side Stone', icon: 'side_stone', active: 0 },
                    { id: 3, label: 'Three Stone', icon: 'three_stone', active: 0 },
                    { id: 4, label: 'Vintage', icon: 'vintage', active: 0 },
                    { id: 5, label: 'Halo', icon: 'halo', active: 0 },
                  ]
                },
                {
                  type: 'box',
                  label: "Which of the 4c’s is important to you? (Cut, Color, Clarity & Carat)",
                  value: '4cs_br',
                  multiselect: true,
                  options: [
                    { id: 1, label: 'Color', icon: null, active: 0 },
                    { id: 2, label: 'Clarity', icon: null, active: 0 },
                    { id: 3, label: 'Cut', icon: null, active: 0 },
                    { id: 4, label: 'Carat', icon: null, active: 0 },
                  ]
                },
                {
                  type: 'box',
                  label: "Do you have a budget we should be mindful of?",
                  value: 'budget_br',
                  options: [
                    { id: 1, label: '$1,000 - $1,500', icon: null, active: 0 },
                    { id: 2, label: '$1,500 - $2,000', icon: null, active: 0 },
                    { id: 3, label: '$2,000 - $2,500', icon: null, active: 0 },
                    { id: 4, label: '$2,500 - $3,000', icon: null, active: 0 },
                    { id: 5, label: '$3,000+', icon: null, active: 0 },
                  ]
                },
                {
                  type: 'input',
                  label: "Is there a special date or occasion you're preparing for? We'd love to ensure timely delivery for your important moment.",
                  value: 'occasion_date',
                  answer: ''
                },
                {
                  type: 'image',
                  label: 'Do you have any design inspirations or references images for your dream ring?',
                  value: 'image',
                  media: null
                },
                {
                  type: 'input',
                  label: "Is there anything else we should know to help create your perfect piece?",
                  value: 'piece_description',
                  answer: ''
                },
              ]
            },
          
            fine_jewelry: {
              label: 'Fine Jewelry',
              desciption: 'Help us prepare - answer these questions!',
              id: '2',
              value: 'fine_jewelry',
              filters: [
                {
                  type: 'radio',
                  label: 'What type of fine jewelry are you interested in exploring?',
                  value: 'style',
                  subSelectKey:'jewelry',
                  options: [
                    { id: 1, value:"ring", label: 'Rings', icon: 'full_eternity_ring', active: 1 },
                    { id: 2, value:"pendant", label: 'Pendants & Necklaces', icon: 'fashion_necklace', active: 0 },
                    { id: 3, value:"bracelet", label: 'Bracelets', icon: 'tennis_bracelet', active: 0 },
                    { id: 4, value:"earrings", label: 'Earrings', icon: 'hoop_earring', active: 0 }
                  ]
                },
               
                {
                  type: 'box',
                  label: 'Do you have a specific style or category in mind?',
                  value: 'jewelry',
                  multiselect: true,
                  allOptions: {
                    ring: [
                      { id: 1, label: 'Eternity Rings', icon: 'full_eternity_ring', active: 0 },
                      { id: 2, label: 'Toi Et Moi Rings', icon: 'toi_et_moi_ring', active: 0 },
                      { id: 3, label: 'Five Stone Rings', icon: 'five_stone', active: 0 },
                      { id: 4, label: 'Seven Stone Rings', icon: 'seven_stone', active: 0 },
                      { id: 5, label: 'Couple Rings', icon: 'couple_bands_ring', active: 0 },
                      { id: 6, label: "Women's Wedding Rings", icon: 'womens_wedding', active: 0 },
                    ],
                    pendant: [
                      { id: 1, label: 'Tennis Necklaces', icon: 'tennis_necklace', active: 0 },
                      { id: 2, label: 'Solitaire Necklaces', icon: 'solitaire_necklace', active: 0 },
                      { id: 3, label: 'Fashion Necklaces', icon: 'fashion_necklace', active: 0 },
                      { id: 4, label: 'Initial Necklaces', icon: 'initial-necklace', active: 0 },
                    ],
                    bracelet: [
                      { id: 1, label: 'Tennis Bracelets', icon: 'tennis_bracelet', active: 0 },
                      { id: 2, label: 'Fashion Bracelets', icon: 'fashion_bracelet', active: 0 },
                      { id: 3, label: 'Openable Bangle Bracelets', icon: 'openable_bangle', active: 0 },
                    ],
                    earrings: [
                      { id: 1, label: 'Stud Earrings', icon: 'stud_earring', active: 0 },
                      { id: 2, label: 'Hoop Earrings', icon: 'hoop_earring', active: 0 },
                      { id: 3, label: 'Fashion Earrings', icon: 'fashion_earring', active: 0 },
                    ],
                  },
                  options: [
                      { id: 1, label: 'Eternity Rings', icon: 'full_eternity_ring', active: 0 },
                      { id: 2, label: 'Toi Et Moi Rings', icon: 'toi_et_moi_ring', active: 0 },
                      { id: 3, label: 'Five Stone Rings', icon: 'five_stone', active: 0 },
                      { id: 4, label: 'Seven Stone Rings', icon: 'seven_stone', active: 0 },
                      { id: 5, label: 'Couple Rings', icon: 'couple_bands_ring', active: 0 },
                      { id: 6, label: "Women's Wedding Rings", icon: 'womens_wedding', active: 0 },
                      
                  ]
                },
                {
                  type: 'input',
                  label: "What's the occasion or purpose for this jewelry purchase?",
                  value: 'occasion',
                  answer: ''
                },
                {
                  type: 'input',
                  label: "Are there any particular questions you'd like our jewelry consultant to address during your appointment?",
                  value: 'questions',
                  answer: ''
                },
                {
                  type: 'disclaimer',
                  label: "While we maintain an extensive collection, we may not have every specific piece readily available, but we'll work to either procure your ideal jewelry or suggest beautiful alternatives that match your vision.",
                  value: 'disclaimer',
                },
              ]
            },
          
            bespoke: {
              label: 'Bespoke Jewelry',
              desciption: 'Help us prepare - answer these questions!',
              id: '3',
              value: 'bespoke',
              filters: [
                {
                  type: 'radio',
                  label: 'Are you looking to create something entirely from scratch, or would you prefer a piece similar to a reference design with modifications?',
                  value: 'bespoke_type',
                  options: [
                    { id: 1, label: 'Modify a reference design', icon: null, active: 0 },
                    { id: 2, label: 'Create from scratch', icon: null, active: 0 },
                  ]
                },
                {
                  type: 'image',
                  label: 'Do you have any reference images or design inspirations for your custom piece?',
                  value: 'reference_image',
                  media: null
                },
                {
                  type: 'box',
                  label: 'What category of jewelry are you interested in creating?',
                  value: 'category_br',
                  multiselect: true,
                  options: [
                    { id: 1, label: 'Rings', icon: 'full_eternity_ring', active: 0 },
                    { id: 2, label: 'Pendants & Necklaces', icon: 'fashion_necklace', active: 0 },
                    { id: 3, label: 'Bracelets', icon: 'tennis_bracelet', active: 0 },
                    { id: 4, label: 'Earrings', icon: 'hoop_earring', active: 0 }
                  ]
                },
                {
                  type: 'input',
                  label: 'What occasion or purpose will this bespoke piece serve?',
                  value: 'occasion',
                  answer: ''
                },
                {
                  type: 'box',
                  label: 'What budget range are you considering for this custom creation?',
                  value: 'budget_br',
                  options: [
                    { id: 1, label: '$2,000 - $3,000', icon: null, active: 0 },
                    { id: 2, label: '$3,000 - $5,000', icon: null, active: 0 },
                    { id: 3, label: '$5,000 - $7,000', icon: null, active: 0 },
                    { id: 4, label: '$7,000 - $10,000', icon: null, active: 0 },
                    { id: 5, label: '$10,000+', icon: null, active: 0 },

                  ]
                }
              ]
            },
          
            bridal: {
              label: 'Bridal Consultation',
              desciption: 'Help us prepare - answer these questions!',
              id: '4',
              value: 'bridal',
              filters: [
                {
                  type: 'radio',
                  label: 'Are you looking for bridal jewelry to complement your outfit?',
                  value: 'bridal_jewelry',
                  options: [
                    { id: 1, label: 'Yes', icon: null, active: 1 },
                    { id: 2, label: 'No', icon: null, active: 0 }
                  ]
                },
                {
                  type: 'radio',
                  label: 'Do you have a wedding date set?',
                  value: '',
                  options: [
                    { id: 1, label: "Yes, there’s a date.", icon: null, active: 0 },
                    { id: 2, label: "No, not yet.", icon: null, active: 0 }
                  ]
                },
                {
                  type: 'input',
                  label: 'What style of bridal jewelry interests you?',
                  value: 'bridal_style',
                  answer: ''
                },
                {
                  type: 'box',
                  label: 'What specific jewelry categories are you considering?',
                  value: 'category_br',
                  multiselect: true,
                  options: [
                    { id: 1, label: 'Rings', icon: 'full_eternity_ring', active: 0 },
                    { id: 2, label: 'Pendants & Necklaces', icon: 'fashion_necklace', active: 0 },
                    { id: 3, label: 'Bracelets', icon: 'tennis_bracelet', active: 0 },
                    { id: 4, label: 'Earrings', icon: 'hoop_earring', active: 0 }
                  ]
                },
                {
                  type: 'radio',
                  label: 'Would you prefer to purchase a ready-made piece or have something custom-created from scratch?',
                  value: 'bridal_type',
                  options: [
                    { id: 1, label: 'Ready-made piece', icon: null, active: 0 },
                    { id: 2, label: 'Create from scratch', icon: null, active: 0 }
                  ]
                },
                {
                  type: 'box',
                  label: 'What budget range are you considering for your bridal jewelry?',
                  value: 'budget_br',
                  options: [
                    { id: 1, label: '$2,000 - $3,000', icon: null, active: 0 },
                    { id: 2, label: '$3,000 - $5,000', icon: null, active: 0 },
                    { id: 3, label: '$5,000 - $7,000', icon: null, active: 0 },
                    { id: 4, label: '$7,000 - $10,000', icon: null, active: 0 },
                    { id: 5, label: '$10,000+', icon: null, active: 0 },
                  ]
                }
              ]
            }
          }
          
    }),
    getters: { ...getters },
    actions: {
        ...actions,
        commitMutation: function (mutationToCall, data) {
            try {
                mutations[mutationToCall](this, data)
            } catch (error) {
                console.error('APPOINTMENT MUTATION ERROR - ', mutationToCall, data, error)
                throw error
            }
        }
    }
})